var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControls = function SvgControls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1F5A1",
    d: "M59.709 23.708V0H24.146v23.708H.412v35.589h23.734v23.708H59.71V59.297h23.708V23.708zm19.765 31.62H55.766v23.734H28.089V55.328H4.38V27.677h23.708V3.943h27.677v23.734h23.708z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1F5A1",
    d: "M67.62 47.417h3.943v-3.943h3.942V39.53h-3.942v-3.969H67.62V31.62h-3.969v19.765h3.969zM51.797 43.474h-3.942v3.943h3.942zM51.797 35.563h-3.942v3.968h3.942zM32.032 63.24v3.942H36v3.969h3.943v3.942h3.943v-3.942h3.968v-3.969h3.943v-3.943zM47.854 11.854h-3.968V7.912h-3.943v3.942H36v3.943h-3.968v3.969h19.765v-3.969h-3.943zM47.854 47.417H36v3.968h11.854zM36 43.474h-3.968v3.943H36zM36 35.563h-3.968v3.968H36zM16.235 35.562h-3.969v3.97H8.323v3.942h3.943v3.943h3.969v3.968h3.942V31.62h-3.942z"
  })));
};
export default SvgControls;